export class Canvas2dUnavailableError extends Error {
  constructor() {
    super('canvas 2d context unavailable');
    this.name = 'Canvas2dUnavailableError';
  }
}

export interface Canvas2d {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
}

/** A detached canvas of the given size with its 2d context; throws `Canvas2dUnavailableError` when the browser can't provide one. */
export function createCanvas2d(width: number, height: number): Canvas2d {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Canvas2dUnavailableError();
  return { canvas, ctx };
}
